import _ from "lodash";
import * as config from "../config";
import Storage from "./storage"
import UserHandler from "./user-handler";
import Promise from "es6-promise"
import loggly from "loggly-jslogger";
import browserDetector from "detect-browser";
import LogErrrorsToZoomCloud from "./log-errors-to-zc"

const connectionErrorString = "Sorry, we were unable to establish a network connection to the FaceTec SDK API. Our team has been informed of this error, please try again in a few minutes.";

export default {

  headersAsObj: function(headers){
    var headersObj = {};

    if (typeof(headers.entries) === "function"){
      for (var header of headers.entries()) {
        headersObj[header[0]] = header[1];
      }
    }

    return headersObj;
  },

  handleSoftErrors: function(response) {
    if ((!response.meta) || (!response.meta.ok)) {

      // Handle other errors here
      if (response.meta.ok === false) {
        return response
      }
      else {
        // throw Error(response.statusText);
        this.outputError(response.statusText);
      }
    }
    return response;
  },

  outputError: function(error){
    throw Error(error);
  },

  // Fetch now wraps multiple fetchAttempts
  // Currently we try one at the primary endpoint then a second at the backup endpoint
  fetch: function(method, endpoint, body={}){
    return this.fetchAttempt(config.API_PREFIX, method, endpoint, body)
      .catch( err => {

        // We used to try a SECOND attempt to a backup API endpoint, but that failed just like the first in failure scenarios
        // I'm just commenting this out for now, but I think we can just remove it.
        // if (err.message == connectionErrorString){
        //     return this.fetchAttempt(config.API_BACKUP_PREFIX, method, endpoint, body);
        // } else {
            throw err;
        // }
      });
  },

  fetchAttempt: function(apiPrefix, method, endpoint, body){

    //Set the universal headers
    let headers = new Headers();

    //Unsure if this is the right approach
    var lastResponse;
    var startDate = new Date();

    headers.append("Content-Type","application/json");
    headers.append("Accept","application/json");

    let token = UserHandler.getToken();

    if (token){
      headers.append("X-User-Token",token);
    }

    if (WEBPACK_QA_MODE_ENABLED) {
      headers.append(WEBPACK_QA_MODE_HEADER, WEBPACK_QA_MODE_SECRET);
    }

    //Set the dev password if available
    if (config.DEV_PASS){
      headers.append("X-Dev-Pass",config.DEV_PASS)
    }
    var myInit = {
      method: method,
      headers: headers
    };

    if((method !== "GET") && (method !== "HEAD")) {
      myInit.body = body
    }

    //Instantiate Loggly
    _LTracker.push({
      "logglyKey": config.LOGGLY_KEY,
      "tag" : "sdksite_"+FN_MODE,
      "sendConsoleErrors": true
    });

    //
    // return a promise which will RESOLVE to the result of the request or REJECT if an error occurred during the request or while promising the request response
    //
    return ( fetch(apiPrefix + endpoint, myInit)

      .then( (response) => {
        lastResponse = response;
        return response.json();
      })

      //
      // Fetch only throws errors on network errors, so by placing the catch here
      // we should only be catching network errors that occurred at the time of request
      // Not errors that we threw after receiving, for instance, a 500 request and parsing it
      //
      // As of writing this, there is an ongoing error where client browsers are unable to connect to our API,
      // it's still unclear to us what this error is, it is caught here and sent to Loggly as a 999
      //
      .catch( err => {

        var reqBody = {};
        if (myInit.method == "POST"){
           reqBody = JSON.parse(myInit.body);
        }

        // LOGGLY: ensure that we also add the user guid to this and that it gets properly logged
        var log = {
          "status": 999,
          "method": myInit.method,
          "ok": false,
          "url": apiPrefix + endpoint,
          "reqBody": reqBody, //This won't work if it's requestBody, idk why
          "reqHeaders": this.headersAsObj(myInit.headers),
          "originalError": err.message,
          "ms": new Date().getTime() - startDate.getTime()
        };

        var browser = browserDetector.detect();
        if (browser){
          log.browser = browser.name + " " + browser.version
        }

        _LTracker.push(log);

        if(log.url.indexOf("contact") >  -1) {
          log.filename = "fnapi-client.jsx"
          LogErrrorsToZoomCloud.sendLogs(log, reqBody, headers)
        }
        //
        // Try a backup request made to the API_BACKUP (proxy) server in Northern California
        // We will only try one backup request, this is an attempt to catch these weird failed to fetch errors that we can't pin down
        //

        this.outputError("Sorry, we were unable to establish a network connection to the FaceTec SDK API. Our team has been informed of this error, please try again in a few minutes.")
      })

      .then( this.handleSoftErrors )

      .then( (decodedResponse) => {
        var reqBody = {};
        if (myInit.method == "POST"){
           reqBody = JSON.parse(myInit.body);
        }

        // LOGGLY: ensure that we also add the user guid to this and that it gets properly logged
        //Log this to loggly
        _LTracker.push({
          "status": lastResponse.status,
          "method": myInit.method,
          "ok": lastResponse.ok,
          "url": lastResponse.url,
          "reqBody": reqBody, //This won't work if it's requestBody, idk why
          "reqHeaders": this.headersAsObj(myInit.headers),
          "responseBody": decodedResponse,
          "responseHeaders": this.headersAsObj(lastResponse.headers),
          "ms": new Date().getTime() - startDate.getTime()
        });

        // Request was OK, return the "Data" object on the body
        // Note: this is retur
        if (decodedResponse.meta.ok){
          return decodedResponse;
        }

        // Request failed! throw an error
        else if (decodedResponse.meta.message) {
          let error = new Error(decodedResponse.meta.message);
          error.code = decodedResponse.meta.code;
          error.subCode = decodedResponse.meta.subCode;
          error.message = decodedResponse.meta.message;
          if (error.subCode === "alreadyOnWaitingList") {
            // error.message = "Email support@facetec.com to get login details"
          }
          else {
            if (error.subCode == "badUserToken"){
              return UserHandler.logout(false)
            }
          }
          return Promise.reject( error );
        }

        else {

          let error = new Error("An unexpected response has been returned from the api");
          error.code = 500;
          error.subCode = "unexpectedApiResponse";
          error.details = {
            response: decodedResponse
          };

          return Promise.reject( error );
        }

      })

    )},

  //Sends a GET request to the API
  get: function(endpoint, query={}){

    //Add the query object as a query string to the url
    let queryString = "";
    if (_.isEmpty(query) == false){
      let str = [];
      for(var p in query){
        if (query.hasOwnProperty(p)) {
          str.push(encodeURIComponent(p) + "=" + encodeURIComponent(query[p]));
        }
      }
      queryString = "?" + str.join("&");
    }

    return this.fetch("GET", endpoint + queryString );
  },

  //Sends a POST request to the API
  post: function(endpoint, payload={}, query={}){
    return this.fetch("POST", endpoint, JSON.stringify(payload));
  },

  //Sends a DELETE request to the API
  delete: function(endpoint, payload={}, query={}){
    return this.fetch("DELETE", endpoint, JSON.stringify(payload));
  }

};



// WEBPACK FOOTER //
// ./src/js/utilities/fnapi-client.jsx